/**
 * UltrawhtVisual.js
 * 
 * Displays the visual for the Ultrawht section.
 * Extracted from legacy MainRight.js logic using IlAdd active="uw".
 * Ensures correct markup and class names for CSS compatibility.
 */

export const UltrawhtVisual = ({ lower }) => {
  if (lower === "left") {
    return (<div className="il-add" lower="left" data-beta-flow="true" style={{ backgroundImage: `url("/img/ultrawht/aside-two-uw.jpg")`}}></div>);		
  } else if (lower === "right") {
    return (<div className="il-add" lower="right" data-beta-flow="true" style={{ backgroundImage: `url("/img/ultrawht/aside-three-uw.jpg")`}}></div>);		
  } else {
    // Default or "upper" case
    return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("/img/ultrawht/aside-one-uw.jpg")`}}></div>);
  }
};
